function canInitPhotoswipe() {
    return typeof window.jQuery !== 'undefined' && typeof window.jQuery.fn.initPhotoswipe === 'function';
}

function initPhotoGrids(root) {
    if (!canInitPhotoswipe()) {
        return;
    }

    const $ = window.jQuery;
    const $root = root ? $(root) : $(document);

    $root.find('.icore-photo-grid.dt-gallery-container').addBack('.icore-photo-grid.dt-gallery-container').each(function () {
        const $el = $(this);

        if ($el.data('icore-pswp-ready')) {
            return;
        }

        $el.data('icore-pswp-ready', true);
        $el.initPhotoswipe();
    });
}

function scheduleInit() {
    initPhotoGrids(document);
}

if (document.readyState === 'complete') {
    scheduleInit();
} else {
    window.addEventListener('load', scheduleInit);
}

if (typeof window.jQuery !== 'undefined') {
    window.jQuery(window).on('vc_reload', function () {
        scheduleInit();
    });
}
